<template>
  <div class="event-full">
    <a class="event-full__back" :href="eventsPageUrl">
      <v-icon size="24" color="#333333">chevron_left</v-icon>
      <span>{{ $t('backToEvents') }}</span>
    </a>
    <div class="event-full__content">
      <img src="/assets/sad-ticket.svg" alt="">
      <div class="event-full__text">
        <h1 class="event-full__title">{{ $t('eventFull') }}</h1>
        <p class="event-full__description">{{ $t('eventFullDescription') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'event-full',
  computed: {
    eventsPageUrl() {
      return process.env.VUE_APP_LANDING_URL
    },
  },
}
</script>

<style scoped>
.event-full {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  max-width: 493px;
  margin-bottom: 3rem;
}

.event-full__back {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.27px;
  text-transform: uppercase;
  text-decoration: none;
  color: #333333;
}

.event-full__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.event-full__text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.event-full__title {
  margin: 0;
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 36px;
  line-height: 1.2;
  letter-spacing: -1.08px;
  color: #333333;
}

.event-full__description {
  margin: 0;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.5;
  color: #333333;
}
</style>
